import React from 'react'
import {
    FormControl,
    FormLabel,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Typography,
} from '@material-ui/core'

import { GuestCardPremiumOption } from '../../../../models/Outreach/types'

export function formatPremiumOptionLabel(
    premium: GuestCardPremiumOption,
): string {
    return premium.name
}

interface GuestCardPremiumQuestionProps {
    label: string
    premiums: GuestCardPremiumOption[]
    selectedIds: number[]
    noneSelected: boolean
    onChange: (next: { selectedIds: number[]; noneSelected: boolean }) => void
    disabled?: boolean
    className?: string
    required?: boolean
}

export const GuestCardPremiumQuestion: React.FC<GuestCardPremiumQuestionProps> = ({
    label,
    premiums,
    selectedIds,
    noneSelected,
    onChange,
    disabled,
    className,
    required = false,
}) => {
    const selected = new Set(selectedIds)

    return (
        <FormControl
            component="fieldset"
            className={className}
            fullWidth
            disabled={disabled}
            required={required}
        >
            <FormLabel component="legend">{label}</FormLabel>
            <Typography
                variant="caption"
                color="textSecondary"
                style={{ display: 'block', marginBottom: 4 }}
            >
                Select all that apply
            </Typography>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={noneSelected}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    onChange({
                                        selectedIds: [],
                                        noneSelected: true,
                                    })
                                } else {
                                    onChange({
                                        selectedIds,
                                        noneSelected: false,
                                    })
                                }
                            }}
                            color="primary"
                            disabled={disabled}
                        />
                    }
                    label="No"
                />
                {premiums.map((premium) => (
                    <FormControlLabel
                        key={premium.id}
                        control={
                            <Checkbox
                                checked={selected.has(premium.id)}
                                onChange={(e) => {
                                    const next = new Set(selected)
                                    if (e.target.checked) {
                                        next.add(premium.id)
                                    } else {
                                        next.delete(premium.id)
                                    }
                                    onChange({
                                        selectedIds: Array.from(next),
                                        noneSelected: false,
                                    })
                                }}
                                color="primary"
                                disabled={disabled}
                            />
                        }
                        label={formatPremiumOptionLabel(premium)}
                    />
                ))}
            </FormGroup>
        </FormControl>
    )
}
